module.exports = __webpack_public_path__ + "static/cabin-regular-bb34059b1c5b6a76d5d7b9aa401b3dd4.woff2";